import React from 'react';
import PropTypes from 'prop-types';
import Axios from 'cccisd-axios';
import ClickButton from 'cccisd-click-button';
import Tooltip from 'cccisd-tooltip';
import IconUser from 'cccisd-icons/user';

const Boilerplate = window.cccisd && window.cccisd.boilerplate;
const Fortress = window.cccisd && window.cccisd.fortress;

const LoginAsCareCoordinator = props => {
    const { row } = props;

    if (!row['fields.enrolledInSmartwrap'] || !row['user.username']) {
        return null;
    }

    const currentActingPawnId = Fortress && Fortress.user && Fortress.user.acting && Fortress.user.acting.id;
    const isDisabled = row['pawn.pawnId'] === currentActingPawnId;

    const loginAs = async () => {
        const response = await Axios.post(Boilerplate.route('api.nexus.user.loginAs'), {
            pawnId: row['pawn.pawnId'],
            pawnHash: row['pawn.pawnHash'],
        });

        if (response.data.status === 'success') {
            window.location.href = Boilerplate.url(Fortress.settings.config.after_login_url);
        }
    };

    return (
        <Tooltip title="Login As">
            <ClickButton
                title={<IconUser />}
                className="btn btn-xs btn-warning"
                onClick={loginAs}
                isDisabled={isDisabled}
            />
        </Tooltip>
    );
};

LoginAsCareCoordinator.propTypes = {
    row: PropTypes.object,
};

export default LoginAsCareCoordinator;
